module.exports = __webpack_public_path__ + "static/media/lvjian-fuyoubaojianyuan.28dd8219.png";